import { render, staticRenderFns } from "./VideoPlayerWidget.vue?vue&type=template&id=7a597444&"
import script from "./VideoPlayerWidget.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayerWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports